<template>
  <m-icon
    :icon="icon"
    v-bind="$attrs"
    v-on="$listeners" />
</template>

<script>
import Vue from 'vue'
import Icon from 'material-components-vue/dist/icon'
Vue.use(Icon)

export default {
  props: {
    icon: { required: true, type: String }
  }
}
</script>
